import React from 'react'
import { Dashboard } from '@uppy/react'
import '@uppy/dashboard/dist/style.css'
import '../../../../assets/stylesheets/upload-style.css'

const UploadDashboard = ({ uppy, dashboardConfig }) => {
  if (!uppy) {
    return null
  }

  return (
    <div className={dashboardConfig.containerClass}>
      <Dashboard
        uppy={uppy}
        disableInformer={dashboardConfig.dashboardConfig.disableInformer}
        proudlyDisplayPoweredByUppy={
          dashboardConfig.dashboardConfig.proudlyDisplayPoweredByUppy
        }
        height={dashboardConfig.dashboardConfig.height}
        plugins={dashboardConfig.dashboardConfig.plugins}
        disableThumbnailGenerator={
          dashboardConfig.dashboardConfig.disableThumbnailGenerator
        }
      />
    </div>
  )
}

export default UploadDashboard
